import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink } from "@apollo/client";
import { Config } from '../Constants/Config'

// The URI is resolved per request: Config is filled from /config.json after this module loads.
const link = createHttpLink({
  uri: () => Config.parsUrl + '/graphql',
});

const authLink = new ApolloLink((operation, forward) => {
  // Retrieve the authorization token from local storage.
  const token = localStorage.getItem('access_token');

  // Use the setContext method to set the HTTP headers.
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : ''
    }
  });

  // Call the next link in the middleware chain.
  return forward(operation);
});

const client = new ApolloClient({
  link: authLink.concat(link),
  cache: new InMemoryCache(),
});

export default client;
